// extracted by mini-css-extract-plugin
export default {"background":"matrix_background__vjYjm","glas":"matrix_glas__iVKGV"};